import React from 'react';
import ErrorFallback from './ErrorFallback';

type ErrorBoundaryProps = {
	children: React.ReactNode;
};

type ErrorBoundaryState = {
	hasError: boolean;
	error: Error | null;
	errorInfo: React.ErrorInfo | null;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = {hasError: false, error: null, errorInfo: null};
	}

	static getDerivedStateFromError(): ErrorBoundaryState {
		return {hasError: true, error: null, errorInfo: null};
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		this.setState({error, errorInfo});
		if (process.env.NODE_ENV !== 'production') {
			// eslint-disable-next-line no-console
			console.error('Unexpected application error:', error, errorInfo);
		}
	}

	handleReset = () => {
		this.setState({hasError: false, error: null, errorInfo: null});
	};

	render() {
		const {hasError, error, errorInfo} = this.state;
		if (hasError) {
			return <ErrorFallback error={error} errorInfo={errorInfo} onReset={this.handleReset} />;
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
